// extracted by mini-css-extract-plugin
export var avatar = "_rp-3";
export var avatarContainer = "_rp-2";
export var avatarSpacer = "_rp-5";
export var avatarSpacerContainer = "_rp-4";
export var avatarStackContainer = "_rp-1";
export var bubble = "_rp-0";
export var remainderBubble = "_rp-6";